import * as adal from './adal/adal_request';
import * as fetchData from './fetch_data';
import * as postData from './post_data';

export const bootstrapAppCallback = () => adal.authenticate();
export const login = () => adal.login();
export const logout = () => adal.logout();
export const isAuthenticated = () => adal.isAuthenticated();
export const getCachedUser = () => adal.getCachedUser();

export const whoAmI = () => fetchData.whoAmI();
export const getFullName = id => fetchData.getFullName(id);
export const fetch = (url, maxPageSize, impersonate, ownerId, pageNumber) => fetchData.fetch( // eslint-disable-line
  url,
  maxPageSize,
  impersonate,
  ownerId,
  pageNumber
);
export const fetchPolicyInfo = (url, maxPageSize, personId, ownerId) => fetchData.fetchPolicyInfo(
  url,
  maxPageSize,
  personId,
  ownerId
);
export const executeQuery = query => fetchData.executeQuery(query);

export const post = (url, data) => postData.post(url, data);



// WEBPACK FOOTER //
// ./src/lib/network/webapi/index.js